import { render } from "./Index.vue?vue&type=template&id=dd663496&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=dd663496&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src835202786/src/web-previewer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd663496"]])

export default __exports__